export default __webpack_public_path__ + "static/media/(95).20d35b0c.jpg";